import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
import { getResolutionPlanSSRResource } from '@jira/router-resources__service-desk-ai-context-panel/src/ResolutionPlanSSRResource.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmReportsSatisfactionIssueRoute } from '@jira/router-routes__servicedesk-reports-routes/src/csmReportsSatisfactionIssueRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { reportsIssueViewPageEntryPoint } from './common/reportsIssueViewPage.entrypoint.tsx';

const csmReportsSatisfactionIssuePageEntryPoint = createPageEntryPoint({
	main: reportsIssueViewPageEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmReportsSatisfactionIssueRouteEntry: Route = createEntry(
	csmReportsSatisfactionIssueRoute,
	() => ({
		group: 'customer-service',
		layout: composeLayouts(serviceProjectLayout, embeddedIssuePreloadLayoutBuilder()),

		navigation: {
			sidebarId: SidebarIdCsmApp,
		},

		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getIssueViewResources(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			...getAIContextPanelResources(),
			...getResolutionPlanSSRResource(),
		],

		afterPaint: [LazyIssueApp],
		ufoName: 'service-management.reports.issue',

		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmReportsSatisfactionIssuePageEntryPoint
				: notFoundPageEntrypoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
